import script from "./ActivityLogttery.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityLogttery.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityLogttery.vue?vue&type=style&index=0&id=17923e4a&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17923e4a"]])

export default __exports__